document.addEventListener('click', function (event) {
  const card = event.target.closest('.terramar-variant-card');
  if (!card || card.disabled) return;

  const productSection = card.closest('product-info') || document;
  const variantTitle = card.dataset.variantTitle;

  const radios = Array.from(productSection.querySelectorAll('input[type="radio"]'));

  const matchingRadio = radios.find(function (radio) {
    return radio.value.trim().toLowerCase() === variantTitle.trim().toLowerCase();
  });

  if (matchingRadio) {
    matchingRadio.click();
  }

  syncSelectedCard(productSection, card.dataset.variantId);

  setTimeout(function () {
    syncSelectedCard(productSection, card.dataset.variantId);
  }, 300);
});

function syncSelectedCard(productSection, variantId) {
  const picker = productSection.querySelector('.terramar-variant-image-picker');
  if (!picker) return;

  picker.querySelectorAll('.terramar-variant-card').forEach(function (card) {
    card.classList.remove('is-selected');
  });

  const selectedCard = picker.querySelector(
    '.terramar-variant-card[data-variant-id="' + variantId + '"]'
  );

  if (selectedCard) {
    selectedCard.classList.add('is-selected');
  }
}
